import { FC, useMemo } from 'react'
import Link from 'next/link'
import styles from './SubCategoryCard.module.scss'
import { SubCategoryCardProps as Props } from '../types'
import { routes } from 'utils/routes'

const SubCategoryCard: FC<Props> = ({ subCategory, color }) => {
  const destination = useMemo(
    () => routes(subCategory.locale, '', [subCategory.category.slug, subCategory.slug]).encyclopediaSubCategory,
    [subCategory.locale, subCategory.category.slug, subCategory.slug]
  )

  return (
    <div className={styles['card-wrapper']}>
      <Link href={destination}>
        <a className={styles['sub-category-card']}>
          <h3>{subCategory.title}</h3>
        </a>
      </Link>
      <div className={styles.bg} style={{ backgroundColor: color }} />
    </div>
  )
}

export default SubCategoryCard
